import { render, staticRenderFns } from "./StoreEditor.vue?vue&type=template&id=52bac829&scoped=true&"
import script from "./StoreEditor.vue?vue&type=script&lang=ts&"
export * from "./StoreEditor.vue?vue&type=script&lang=ts&"
import style0 from "./StoreEditor.vue?vue&type=style&index=0&id=52bac829&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bac829",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VCardActions,VForm})
